export default [
    {
        name: 'Contratos',
        url: '/gescon/gestores/contratos',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-GEST-CONT-00',
        badge: {
            variant: 'primary',
            text: 'GESTOR'
        }
    },
    {
        name: 'Requisições',
        url: '/gescon/gestores/requisicoes',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-GEST-REQ-00',
        badge: {
            variant: 'primary',
            text: 'GESTOR'
        }
    },
    {
        name: 'Pagamentos',
        url: '/gescon/gestores/pagamentos',
        icon: 'fa fa-dollar',
        regras: 'GESCON-GEST-PAG-00',
        badge: {
            variant: 'primary',
            text: 'GESTOR'
        }
    },
    {
        name: 'Serviços',
        url: '/gescon/gestores/servicos',
        icon: 'fa fa-truck',
        regras: 'GESCON-GEST-APROV-00',
        badge: {
            variant: 'primary',
            text: 'GESTOR'
        }
    }
]
